var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-help" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `paddingTop:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow05.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("lang.faq.faq"))),
      ]),
      _c("div", { staticClass: "head" }, [
        _vm._v(_vm._s(_vm.$t("lang.faq.introduction"))),
      ]),
      this.appNameFlag("goparty", this.appName)
        ? _c("div", [
            _c("div", { staticClass: "tit", attrs: { id: "tit1" } }, [
              _vm._v("1." + _vm._s(_vm.$t("lang.faq.tit1"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content1")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit2" } }, [
              _vm._v("2." + _vm._s(_vm.$t("lang.faq.tit2"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content2")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit6" } }, [
              _vm._v("3." + _vm._s(_vm.$t("lang.faq.tit6"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content6")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit7" } }, [
              _vm._v("4." + _vm._s(_vm.$t("lang.faq.tit7"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content7")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit8" } }, [
              _vm._v("5." + _vm._s(_vm.$t("lang.faq.tit8"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content8")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit9" } }, [
              _vm._v("6." + _vm._s(_vm.$t("lang.faq.tit9"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content9")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit10" } }, [
              _vm._v("7." + _vm._s(_vm.$t("lang.faq.tit10"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content10")))]),
          ])
        : _vm._e(),
      this.domainNameFlag("joylink", this.domain)
        ? _c("div", [
            _c("div", { staticClass: "tit", attrs: { id: "tit1" } }, [
              _vm._v("1." + _vm._s(_vm.$t("lang.jLink.tit1"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.jLink.content1")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit2" } }, [
              _vm._v("2." + _vm._s(_vm.$t("lang.jLink.tit2"))),
            ]),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.$t("lang.jLink.content2")) },
            }),
            _c("div", { staticClass: "tit", attrs: { id: "tit3" } }, [
              _vm._v("3." + _vm._s(_vm.$t("lang.jLink.tit3"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.jLink.content3")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit4" } }, [
              _vm._v("4." + _vm._s(_vm.$t("lang.jLink.tit4"))),
            ]),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.$t("lang.jLink.content4")) },
            }),
            _c("div", { staticClass: "tit", attrs: { id: "tit5" } }, [
              _vm._v("5." + _vm._s(_vm.$t("lang.jLink.tit5"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.jLink.content5")))]),
          ])
        : _vm._e(),
      this.domainNameFlag("vava", this.domain) ||
      this.domainNameFlag("joychat", this.domain)
        ? _c("div", [
            _vm.gender == 1
              ? _c("div", [
                  _c("div", { staticClass: "tit", attrs: { id: "tit1" } }, [
                    _vm._v("1." + _vm._s(_vm.$t("lang.faq.tit1"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content1")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit2" } }, [
                    _vm._v("2." + _vm._s(_vm.$t("lang.faq.tit2"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content2")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit3" } }, [
                    _vm._v("3." + _vm._s(_vm.$t("lang.faq.tit3"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content3")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit4" } }, [
                    _vm._v("4." + _vm._s(_vm.$t("lang.faq.tit4"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content4")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit5" } }, [
                    _vm._v("5." + _vm._s(_vm.$t("lang.faq.tit5"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content5")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit6" } }, [
                    _vm._v("6." + _vm._s(_vm.$t("lang.faq.tit6"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content6")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit7" } }, [
                    _vm._v("7." + _vm._s(_vm.$t("lang.faq.tit7"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content7")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit8" } }, [
                    _vm._v("8." + _vm._s(_vm.$t("lang.faq.tit8"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content8")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit9" } }, [
                    _vm._v("9." + _vm._s(_vm.$t("lang.faq.tit9"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content9")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit10" } }, [
                    _vm._v("10." + _vm._s(_vm.$t("lang.faq.tit10"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content10")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit11" } }, [
                    _vm._v("11." + _vm._s(_vm.$t("lang.faq.tit11"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faq.content11")))]),
                ])
              : _c("div", [
                  _c("div", { staticClass: "tit", attrs: { id: "tit1" } }, [
                    _vm._v("1." + _vm._s(_vm.$t("lang.faqF.tit1"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content11")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content12")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content13")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content14")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content15")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content16")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit2" } }, [
                    _vm._v("2." + _vm._s(_vm.$t("lang.faqF.tit2"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content21")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content22")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content23")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content24")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content25")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content26")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content27")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit3" } }, [
                    _vm._v("3." + _vm._s(_vm.$t("lang.faqF.tit3"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content31")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content32")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content36")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content37")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content38")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content39")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content40")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit4" } }, [
                    _vm._v("4." + _vm._s(_vm.$t("lang.faqF.tit4"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content41")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content42")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit5" } }, [
                    _vm._v("5." + _vm._s(_vm.$t("lang.faqF.tit5"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content51")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content52")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content53")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content54")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content55")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit6" } }, [
                    _vm._v("6." + _vm._s(_vm.$t("lang.faqF.tit6"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content61")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit7" } }, [
                    _vm._v("7." + _vm._s(_vm.$t("lang.faqF.tit7"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content71")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content72")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content73")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit8" } }, [
                    _vm._v("8." + _vm._s(_vm.$t("lang.faqF.tit8"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content80")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content81")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content82")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content83")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content84")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content85")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content86")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content87")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit9" } }, [
                    _vm._v("9." + _vm._s(_vm.$t("lang.faqF.tit9"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content90")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content91")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content92")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content93")))]),
                  _c("div", { staticClass: "tit", attrs: { id: "tit10" } }, [
                    _vm._v("10." + _vm._s(_vm.$t("lang.faqF.tit10"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content100")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content101")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.faqF.content102")))]),
                ]),
          ])
        : _vm._e(),
      this.domainNameFlag("echo", this.domain)
        ? _c("div", [
            _c("div", { staticClass: "tit", attrs: { id: "tit1" } }, [
              _vm._v(_vm._s(_vm.$t("lang.echo.tit1"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.echo.content1")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit2" } }, [
              _vm._v(_vm._s(_vm.$t("lang.echo.tit2"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.echo.content2")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit3" } }, [
              _vm._v(_vm._s(_vm.$t("lang.echo.tit3"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.echo.content3")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit4" } }, [
              _vm._v(_vm._s(_vm.$t("lang.echo.tit4"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.echo.content4")))]),
            _c("div", { staticClass: "tit", attrs: { id: "tit5" } }, [
              _vm._v(_vm._s(_vm.$t("lang.echo.tit5"))),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.echo.content5")))]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }